import { render, staticRenderFns } from "./HEADLINE.vue?vue&type=template&id=1c492442&scoped=true&"
import script from "./HEADLINE.vue?vue&type=script&lang=js&"
export * from "./HEADLINE.vue?vue&type=script&lang=js&"
import style0 from "./HEADLINE.vue?vue&type=style&index=0&id=1c492442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c492442",
  null
  
)

export default component.exports